import { tag } from "../../../model/tag";

export interface IState {
    tags: Array<tag>;
    tag?: tag;
    edit?: boolean;
    loading?: boolean;
}

export const DefaultState = (): IState => ({
    tags: [],
})